/**
 * @generated SignedSource<<161306dc4e3cc82519fb1cfeefbe2315>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TopicPageQuery$variables = {
  goalFilter: string;
  helpPointersTqlFilter: string;
  isTimelineView: boolean;
  learningsFilter: string;
  pageSize?: number | null;
  projectFilter?: string | null;
  projectTimelineQuery?: string | null;
  shouldFetchKnowledgeTabData: boolean;
  shouldFetchProjectAndGoalsTabData: boolean;
  shouldFetchUpdatesTabData: boolean;
  tagUuid: string;
  workspaceUuid: string;
};
export type TopicPageQuery$data = {
  readonly tagByUuid: {
    readonly name: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"TopicHeader_data">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TopicContentRefreshed_data">;
};
export type TopicPageQuery = {
  response: TopicPageQuery$data;
  variables: TopicPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalFilter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpPointersTqlFilter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTimelineView"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "learningsFilter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectFilter"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectTimelineQuery"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchKnowledgeTabData"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectAndGoalsTabData"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchUpdatesTabData"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagUuid"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v12 = {
  "kind": "Variable",
  "name": "tagUuid",
  "variableName": "tagUuid"
},
v13 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v14 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "tagUuid"
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v18 = {
  "kind": "ScalarField",
  "name": "description"
},
v19 = {
  "kind": "ScalarField",
  "name": "watching"
},
v20 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  },
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "learningsFilter"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "CREATION_DATE_DESC"
  },
  (v13/*: any*/)
],
v21 = {
  "kind": "ScalarField",
  "name": "count"
},
v22 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v23 = {
  "kind": "ScalarField",
  "name": "watcherCount"
},
v24 = {
  "kind": "ScalarField",
  "name": "summary"
},
v25 = {
  "kind": "ScalarField",
  "name": "ari"
},
v26 = {
  "kind": "ScalarField",
  "name": "key"
},
v27 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v16/*: any*/)
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "label"
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "kind": "ScalarField",
  "name": "picture"
},
v31 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v32 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v33 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v15/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/)
    ]
  },
  (v32/*: any*/),
  (v16/*: any*/)
],
v34 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v33/*: any*/)
},
v35 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v36 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v33/*: any*/)
},
v37 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v38 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v39 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v40 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "helpPointersTqlFilter"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "TEAM_ID_ASC"
  },
  (v13/*: any*/)
],
v41 = {
  "kind": "ScalarField",
  "name": "type"
},
v42 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v43 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  (v12/*: any*/)
],
v44 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v45 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v46 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v47 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v16/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        (v31/*: any*/),
        (v15/*: any*/),
        (v46/*: any*/)
      ]
    }
  ]
},
v48 = {
  "kind": "ScalarField",
  "name": "canCommentOnUpdates"
},
v49 = {
  "kind": "ScalarField",
  "name": "private"
},
v50 = {
  "concreteType": "IconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "ThemeURIs",
      "kind": "LinkedField",
      "name": "square",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "light"
        },
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "transparent"
        }
      ]
    }
  ]
},
v51 = [
  (v16/*: any*/),
  (v35/*: any*/)
],
v52 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v53 = [
  (v26/*: any*/),
  (v25/*: any*/),
  (v16/*: any*/)
],
v54 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v55 = {
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            (v54/*: any*/),
            (v25/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v35/*: any*/),
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v32/*: any*/),
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v30/*: any*/),
                    (v15/*: any*/),
                    (v46/*: any*/),
                    (v31/*: any*/)
                  ]
                },
                (v16/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v42/*: any*/)
  ]
},
v56 = [
  (v15/*: any*/)
],
v57 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": (v56/*: any*/)
    },
    (v16/*: any*/)
  ]
},
v58 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v59 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v58/*: any*/)
},
v60 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v61 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v28/*: any*/),
  (v59/*: any*/),
  {
    "alias": "tooltip",
    "args": (v60/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v60/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v58/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v62 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v61/*: any*/)
},
v63 = {
  "kind": "ScalarField",
  "name": "value"
},
v64 = [
  (v63/*: any*/),
  (v28/*: any*/),
  (v59/*: any*/)
],
v65 = {
  "concreteType": "CompletionProjectState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": (v64/*: any*/)
},
v66 = {
  "kind": "ScalarField",
  "name": "archived"
},
v67 = {
  "kind": "ScalarField",
  "name": "title"
},
v68 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v61/*: any*/)
},
v69 = [
  (v28/*: any*/),
  (v59/*: any*/),
  (v63/*: any*/),
  (v65/*: any*/)
],
v70 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v71 = {
  "kind": "ScalarField",
  "name": "url"
},
v72 = [
  (v16/*: any*/)
],
v73 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v74 = [
  (v63/*: any*/),
  (v16/*: any*/)
],
v75 = {
  "kind": "ScalarField",
  "name": "subType"
},
v76 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v77 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v78 = {
  "kind": "ScalarField",
  "name": "score"
},
v79 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v77/*: any*/),
    (v59/*: any*/),
    (v63/*: any*/),
    (v78/*: any*/)
  ]
},
v80 = [
  (v77/*: any*/),
  (v59/*: any*/),
  (v78/*: any*/),
  (v63/*: any*/),
  (v79/*: any*/)
],
v81 = [
  (v12/*: any*/)
],
v82 = [
  {
    "kind": "ScalarField",
    "name": "atRisk"
  },
  {
    "kind": "ScalarField",
    "name": "onTrack"
  },
  {
    "kind": "ScalarField",
    "name": "offTrack"
  },
  {
    "kind": "ScalarField",
    "name": "paused"
  },
  {
    "kind": "ScalarField",
    "name": "pending"
  },
  {
    "kind": "ScalarField",
    "name": "done"
  },
  {
    "kind": "ScalarField",
    "name": "cancelled"
  }
],
v83 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "pageSize"
},
v84 = [
  (v83/*: any*/),
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "goalFilter"
  },
  {
    "kind": "Literal",
    "name": "sorts",
    "value": [
      "TARGET_DATE_ASC"
    ]
  },
  (v13/*: any*/)
],
v85 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        (v31/*: any*/)
      ]
    },
    (v16/*: any*/)
  ]
},
v86 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v61/*: any*/)
},
v87 = {
  "kind": "Literal",
  "name": "sort",
  "value": [
    "STATUS_ASC",
    "TARGET_DATE_ASC",
    "ID_ASC"
  ]
},
v88 = [
  (v83/*: any*/),
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "projectFilter"
  },
  {
    "kind": "Literal",
    "name": "shouldRefetch",
    "value": true
  },
  (v87/*: any*/),
  (v13/*: any*/)
],
v89 = [
  (v83/*: any*/),
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "projectTimelineQuery"
  },
  (v87/*: any*/),
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TopicPageQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "goalFilter",
            "variableName": "goalFilter"
          },
          {
            "kind": "Variable",
            "name": "helpPointersTqlFilter",
            "variableName": "helpPointersTqlFilter"
          },
          {
            "kind": "Variable",
            "name": "isTimelineView",
            "variableName": "isTimelineView"
          },
          {
            "kind": "Variable",
            "name": "learningsFilter",
            "variableName": "learningsFilter"
          },
          {
            "kind": "Variable",
            "name": "pageSize",
            "variableName": "pageSize"
          },
          {
            "kind": "Variable",
            "name": "projectFilter",
            "variableName": "projectFilter"
          },
          {
            "kind": "Variable",
            "name": "projectTimelineQuery",
            "variableName": "projectTimelineQuery"
          },
          {
            "kind": "Variable",
            "name": "shouldFetchKnowledgeTabData",
            "variableName": "shouldFetchKnowledgeTabData"
          },
          {
            "kind": "Variable",
            "name": "shouldFetchProjectAndGoalsTabData",
            "variableName": "shouldFetchProjectAndGoalsTabData"
          },
          {
            "kind": "Variable",
            "name": "shouldFetchUpdatesTabData",
            "variableName": "shouldFetchUpdatesTabData"
          },
          (v12/*: any*/),
          (v13/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TopicContentRefreshed_data"
      },
      {
        "args": (v14/*: any*/),
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tagByUuid",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "TopicHeader_data"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v10/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Operation",
    "name": "TopicPageQuery",
    "selections": [
      {
        "args": (v14/*: any*/),
        "concreteType": "Tag",
        "kind": "LinkedField",
        "name": "tagByUuid",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/)
        ]
      },
      {
        "condition": "shouldFetchKnowledgeTabData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v20/*: any*/),
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "learningTql",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "concreteType": "LearningEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Learning",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          (v16/*: any*/),
                          (v23/*: any*/),
                          {
                            "concreteType": "TagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TagEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v15/*: any*/),
                                      (v23/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v22/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v24/*: any*/),
                          (v18/*: any*/),
                          (v17/*: any*/),
                          (v25/*: any*/),
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/),
                              (v15/*: any*/),
                              (v17/*: any*/),
                              (v25/*: any*/),
                              (v27/*: any*/),
                              {
                                "concreteType": "ProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v29/*: any*/)
                              }
                            ]
                          },
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v26/*: any*/),
                              (v15/*: any*/),
                              (v17/*: any*/),
                              (v25/*: any*/),
                              (v27/*: any*/),
                              {
                                "concreteType": "GoalState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v29/*: any*/)
                              }
                            ]
                          },
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isRecentlyAdded"
                              }
                            ]
                          }
                        ],
                        "type": "Highlight",
                        "abstractKey": "__isHighlight"
                      }
                    ]
                  },
                  (v38/*: any*/)
                ]
              },
              (v39/*: any*/)
            ]
          },
          {
            "args": (v20/*: any*/),
            "filters": [
              "workspaceUuid",
              "q",
              "sort"
            ],
            "handle": "connection",
            "key": "HelpAndKnowledgeLearnings__learningTql",
            "kind": "LinkedHandle",
            "name": "learningTql"
          },
          {
            "args": (v40/*: any*/),
            "concreteType": "HelpPointerConnection",
            "kind": "LinkedField",
            "name": "helpPointerTql",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "concreteType": "HelpPointerEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "HelpPointer",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "cloudId"
                      },
                      (v15/*: any*/),
                      (v18/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "link"
                      },
                      (v41/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "editable"
                      },
                      {
                        "concreteType": "Icon",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "color"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "shortName"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpPointerOwner",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "smallAvatarImageUrl"
                          }
                        ]
                      },
                      {
                        "concreteType": "TagConnection",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TagEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Tag",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v15/*: any*/),
                                  (v17/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v22/*: any*/)
                    ]
                  },
                  (v38/*: any*/)
                ]
              },
              (v39/*: any*/),
              (v42/*: any*/)
            ]
          },
          {
            "args": (v40/*: any*/),
            "filters": [
              "q",
              "workspaceUuid",
              "sort"
            ],
            "handle": "connection",
            "key": "HelpPointers_helpPointerTql",
            "kind": "LinkedHandle",
            "name": "helpPointerTql"
          }
        ]
      },
      {
        "condition": "shouldFetchUpdatesTabData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v43/*: any*/),
            "concreteType": "UpdateConnection",
            "kind": "LinkedField",
            "name": "updatesWithTag",
            "plural": false,
            "selections": [
              {
                "concreteType": "UpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v47/*: any*/),
                          (v25/*: any*/),
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              (v17/*: any*/),
                              (v27/*: any*/),
                              (v16/*: any*/),
                              (v19/*: any*/),
                              {
                                "concreteType": "TownsquareProjectCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canWatchProject"
                                  },
                                  (v48/*: any*/)
                                ]
                              },
                              (v49/*: any*/),
                              (v50/*: any*/),
                              (v26/*: any*/),
                              (v15/*: any*/),
                              {
                                "concreteType": "ProjectUpdate",
                                "kind": "LinkedField",
                                "name": "latestUserUpdate",
                                "plural": false,
                                "selections": (v51/*: any*/)
                              },
                              (v52/*: any*/)
                            ]
                          },
                          (v35/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDate"
                          },
                          {
                            "concreteType": "ProjectChangelogItem",
                            "kind": "LinkedField",
                            "name": "changelog",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "newValue"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "oldValue"
                              },
                              (v16/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "LearningConnection",
                            "kind": "LinkedField",
                            "name": "learnings",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "LearningEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Learning",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v41/*: any*/),
                                      (v17/*: any*/),
                                      (v16/*: any*/),
                                      (v24/*: any*/),
                                      (v18/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v25/*: any*/),
                                          {
                                            "concreteType": "Project",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": (v53/*: any*/)
                                          },
                                          {
                                            "concreteType": "Goal",
                                            "kind": "LinkedField",
                                            "name": "goal",
                                            "plural": false,
                                            "selections": (v53/*: any*/)
                                          },
                                          (v34/*: any*/),
                                          (v35/*: any*/),
                                          (v36/*: any*/),
                                          (v37/*: any*/)
                                        ],
                                        "type": "Highlight",
                                        "abstractKey": "__isHighlight"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v21/*: any*/)
                            ]
                          },
                          (v55/*: any*/),
                          (v54/*: any*/),
                          (v57/*: any*/),
                          (v62/*: any*/),
                          {
                            "alias": "newProjectState",
                            "concreteType": "ProjectState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": [
                              (v63/*: any*/),
                              (v28/*: any*/),
                              (v59/*: any*/),
                              (v65/*: any*/)
                            ]
                          },
                          (v24/*: any*/),
                          {
                            "concreteType": "UpdateNote",
                            "kind": "LinkedField",
                            "name": "notes",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              (v66/*: any*/),
                              (v67/*: any*/),
                              (v24/*: any*/),
                              (v16/*: any*/),
                              (v22/*: any*/)
                            ]
                          },
                          (v68/*: any*/),
                          {
                            "alias": "oldProjectState",
                            "concreteType": "ProjectState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v69/*: any*/)
                          },
                          {
                            "concreteType": "MilestoneConnection",
                            "kind": "LinkedField",
                            "name": "milestones",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MilestoneEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Milestone",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v16/*: any*/),
                                      (v67/*: any*/),
                                      (v70/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetDateType"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "status"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v21/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v71/*: any*/),
                                  {
                                    "concreteType": "Goal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/),
                                      (v16/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "GoalUpdate"
                              }
                            ],
                            "type": "Update",
                            "abstractKey": "__isUpdate"
                          }
                        ],
                        "type": "ProjectUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v47/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v25/*: any*/),
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              (v17/*: any*/),
                              (v27/*: any*/),
                              (v16/*: any*/),
                              (v19/*: any*/),
                              {
                                "concreteType": "TownsquareGoalCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canWatchGoal"
                                  },
                                  (v48/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "parentGoal",
                                "plural": false,
                                "selections": (v72/*: any*/)
                              },
                              (v26/*: any*/),
                              (v15/*: any*/),
                              (v73/*: any*/),
                              {
                                "concreteType": "GoalUpdate",
                                "kind": "LinkedField",
                                "name": "latestUserUpdate",
                                "plural": false,
                                "selections": (v51/*: any*/)
                              },
                              (v52/*: any*/),
                              {
                                "concreteType": "GoalConnection",
                                "kind": "LinkedField",
                                "name": "subGoals",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "MetricTargetConnection",
                                "kind": "LinkedField",
                                "name": "metricTargets",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "MetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "MetricTarget",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "startValue"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "targetValue"
                                          },
                                          (v16/*: any*/),
                                          {
                                            "concreteType": "MetricValue",
                                            "kind": "LinkedField",
                                            "name": "snapshotValue",
                                            "plural": false,
                                            "selections": (v74/*: any*/)
                                          },
                                          {
                                            "concreteType": "Metric",
                                            "kind": "LinkedField",
                                            "name": "metric",
                                            "plural": false,
                                            "selections": [
                                              (v16/*: any*/),
                                              (v15/*: any*/),
                                              (v41/*: any*/),
                                              (v75/*: any*/),
                                              (v66/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "source"
                                              },
                                              {
                                                "concreteType": "MetricValue",
                                                "kind": "LinkedField",
                                                "name": "latestValue",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "time"
                                                  },
                                                  (v16/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "GoalProgress",
                                "kind": "LinkedField",
                                "name": "progress",
                                "plural": false,
                                "selections": [
                                  (v76/*: any*/),
                                  (v41/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v35/*: any*/),
                          {
                            "concreteType": "GoalMetricUpdateConnection",
                            "kind": "LinkedField",
                            "name": "metricUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GoalMetricUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "GoalMetricUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "newStartValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newTargetValue"
                                      },
                                      {
                                        "concreteType": "MetricValue",
                                        "kind": "LinkedField",
                                        "name": "newValue",
                                        "plural": false,
                                        "selections": (v74/*: any*/)
                                      },
                                      {
                                        "concreteType": "Metric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v16/*: any*/),
                                          (v15/*: any*/),
                                          (v41/*: any*/),
                                          (v75/*: any*/),
                                          (v66/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "MetricValue",
                                        "kind": "LinkedField",
                                        "name": "oldValue",
                                        "plural": false,
                                        "selections": (v74/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "GoalProgress",
                            "kind": "LinkedField",
                            "name": "newProgress",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/),
                              (v76/*: any*/)
                            ]
                          },
                          (v55/*: any*/),
                          (v57/*: any*/),
                          (v54/*: any*/),
                          {
                            "alias": "newGoalState",
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": [
                              (v63/*: any*/),
                              (v77/*: any*/),
                              (v59/*: any*/),
                              (v78/*: any*/),
                              (v79/*: any*/)
                            ]
                          },
                          (v62/*: any*/),
                          (v24/*: any*/),
                          {
                            "concreteType": "UpdateNote",
                            "kind": "LinkedField",
                            "name": "notes",
                            "plural": true,
                            "selections": [
                              (v66/*: any*/),
                              (v17/*: any*/),
                              (v67/*: any*/),
                              (v24/*: any*/),
                              (v16/*: any*/)
                            ]
                          },
                          (v68/*: any*/),
                          {
                            "alias": "oldGoalState",
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v80/*: any*/)
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v71/*: any*/)
                                ],
                                "type": "GoalUpdate"
                              }
                            ],
                            "type": "Update",
                            "abstractKey": "__isUpdate"
                          }
                        ],
                        "type": "GoalUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v72/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v38/*: any*/)
                ]
              },
              (v39/*: any*/)
            ]
          },
          {
            "args": (v43/*: any*/),
            "filters": [
              "tagUuid"
            ],
            "handle": "connection",
            "key": "UpdatesTab_updatesWithTag",
            "kind": "LinkedHandle",
            "name": "updatesWithTag"
          }
        ]
      },
      {
        "condition": "shouldFetchProjectAndGoalsTabData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v14/*: any*/),
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "tagByUuid",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "projectUsageCount"
              },
              {
                "kind": "ScalarField",
                "name": "goalUsageCount"
              }
            ]
          },
          {
            "args": (v81/*: any*/),
            "concreteType": "StatusSummaryForTag",
            "kind": "LinkedField",
            "name": "projectStatusSummaryForTag",
            "plural": false,
            "selections": (v82/*: any*/)
          },
          {
            "alias": "goalSearch",
            "args": (v84/*: any*/),
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalTql",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v85/*: any*/),
                      (v86/*: any*/),
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": (v80/*: any*/)
                      },
                      (v17/*: any*/),
                      (v26/*: any*/),
                      (v73/*: any*/),
                      (v15/*: any*/),
                      (v22/*: any*/)
                    ]
                  },
                  (v38/*: any*/)
                ]
              },
              (v39/*: any*/)
            ]
          },
          {
            "alias": "goalSearch",
            "args": (v84/*: any*/),
            "filters": [
              "workspaceUuid",
              "q",
              "sorts"
            ],
            "handle": "connection",
            "key": "GoalsList__goalSearch",
            "kind": "LinkedHandle",
            "name": "goalTql"
          },
          {
            "args": (v81/*: any*/),
            "concreteType": "StatusSummaryForTag",
            "kind": "LinkedField",
            "name": "goalStatusSummaryForTag",
            "plural": false,
            "selections": (v82/*: any*/)
          },
          {
            "condition": "isTimelineView",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v88/*: any*/),
                "concreteType": "ProjectConnection",
                "kind": "LinkedField",
                "name": "projectTql",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "concreteType": "ProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v85/*: any*/),
                          (v26/*: any*/),
                          (v15/*: any*/),
                          (v17/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v86/*: any*/),
                          {
                            "concreteType": "ProjectState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": (v69/*: any*/)
                          },
                          (v22/*: any*/)
                        ]
                      },
                      (v38/*: any*/)
                    ]
                  },
                  (v39/*: any*/)
                ]
              },
              {
                "args": (v88/*: any*/),
                "filters": [
                  "workspaceUuid",
                  "q",
                  "sort",
                  "shouldRefetch"
                ],
                "handle": "connection",
                "key": "ProjectList__projectTql",
                "kind": "LinkedHandle",
                "name": "projectTql"
              }
            ]
          },
          {
            "condition": "isTimelineView",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "projectTimeline",
                "args": (v89/*: any*/),
                "concreteType": "ProjectConnection",
                "kind": "LinkedField",
                "name": "projectTql",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "concreteType": "ProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "startDate"
                          },
                          (v35/*: any*/),
                          {
                            "concreteType": "ProjectState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": (v64/*: any*/)
                          },
                          (v70/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "targetDateConfidence"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "targetDateSet"
                          },
                          (v16/*: any*/),
                          (v26/*: any*/),
                          (v15/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          {
                            "concreteType": "ProjectPhaseDetails",
                            "kind": "LinkedField",
                            "name": "newPhase",
                            "plural": false,
                            "selections": (v56/*: any*/)
                          },
                          (v22/*: any*/)
                        ]
                      },
                      (v38/*: any*/)
                    ]
                  },
                  (v39/*: any*/)
                ]
              },
              {
                "alias": "projectTimeline",
                "args": (v89/*: any*/),
                "filters": [
                  "workspaceUuid",
                  "q",
                  "directoryViewUuid",
                  "sort"
                ],
                "handle": "connection",
                "key": "ProjectTimeline__projectTimeline",
                "kind": "LinkedHandle",
                "name": "projectTql"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "836653ea5e9592d102c5c84f2f644bd5",
    "id": null,
    "metadata": {},
    "name": "TopicPageQuery",
    "operationKind": "query",
    "text": "query TopicPageQuery(\n  $tagUuid: UUID!\n  $projectFilter: String\n  $learningsFilter: String!\n  $pageSize: Int\n  $shouldFetchUpdatesTabData: Boolean!\n  $shouldFetchKnowledgeTabData: Boolean!\n  $shouldFetchProjectAndGoalsTabData: Boolean!\n  $projectTimelineQuery: String\n  $goalFilter: String!\n  $isTimelineView: Boolean!\n  $helpPointersTqlFilter: String!\n  $workspaceUuid: UUID!\n) {\n  ...TopicContentRefreshed_data_2K8Y9H\n  tagByUuid(uuid: $tagUuid) {\n    name\n    ...TopicHeader_data\n    id\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n  capabilities {\n    canWatchGoal\n  }\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalResultRow_data on Goal {\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  dueDate {\n    ...TargetDate\n  }\n  state {\n    ...GoalState\n  }\n  ...GoalName\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newGoalState: newState {\n    ...GoalState\n  }\n  oldGoalState: oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalStatusSummary_data_2v8OKf on Query {\n  goalStatusSummaryForTag(tagUuid: $tagUuid) {\n    atRisk\n    onTrack\n    offTrack\n    paused\n    pending\n    done\n    cancelled\n  }\n}\n\nfragment GoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  goal {\n    id\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n    ...MetricChart\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  creationDate\n  editDate\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newGoalState: newState {\n    value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment GoalsList_data_4xBZhq on Query {\n  goalSearch: goalTql(first: $pageSize, workspaceUuid: $workspaceUuid, q: $goalFilter, sorts: [TARGET_DATE_ASC]) {\n    count\n    edges {\n      node {\n        id\n        ...GoalResultRow_data\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment GoalsSection_data_4vWrFT on Query {\n  tagByUuid(uuid: $tagUuid) {\n    goalUsageCount\n    id\n  }\n  ...GoalsList_data_4xBZhq\n  ...GoalStatusSummary_data_2v8OKf\n}\n\nfragment HelpAndKnowledgeTab_data_3wgndL on Query {\n  ...Learnings_data_10Kyey\n  ...HelpPointers_data_db3TK\n}\n\nfragment HelpPointers_data_db3TK on Query {\n  helpPointerTql(q: $helpPointersTqlFilter, workspaceUuid: $workspaceUuid, first: 10, sort: TEAM_ID_ASC) {\n    count\n    edges {\n      node {\n        id\n        cloudId\n        name\n        description\n        link\n        type\n        editable\n        icon {\n          id\n          color\n          shortName\n        }\n        owner {\n          id\n          displayName\n          smallAvatarImageUrl\n        }\n        tags {\n          edges {\n            node {\n              id\n              name\n              uuid\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment LearningCard_cardQuery on Learning {\n  uuid\n  id\n  summary\n  description\n  type\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningTags_data on TagConnection {\n  edges {\n    node {\n      id\n      name\n      watcherCount\n    }\n  }\n}\n\nfragment Learning_data on Highlight {\n  __isHighlight: __typename\n  __typename\n  id\n  summary\n  description\n  uuid\n  ari\n  project {\n    id\n    key\n    name\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  goal {\n    id\n    key\n    name\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningsSummary_data on ProjectUpdate {\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment Learnings_data_10Kyey on Query {\n  learningTql(first: 5, workspaceUuid: $workspaceUuid, q: $learningsFilter, sort: CREATION_DATE_DESC) {\n    count\n    edges {\n      node {\n        id\n        project {\n          __typename\n          id\n        }\n        ...Learning_data\n        ...TopicLearning_data\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          source\n          latestValue {\n            time\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment MilestoneCard_cardQuery on Milestone {\n  uuid\n  ...MilestoneFields\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment MilestonesSummary_data on ProjectUpdate {\n  milestones {\n    edges {\n      node {\n        ...MilestoneCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment MissedProjectUpdateCard on ProjectUpdate {\n  id\n  ari\n  uuid\n  project {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop_PTxnb\n  ...ProjectUpdateTargetDateAutoUpdated\n  ...LearningsSummary_data\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectBar on Project {\n  startDate\n  creationDate\n  state {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n  targetDate\n  targetDateConfidence\n  targetDateSet\n  ...ProjectName_data\n  ...utilsGetProjectTargetEndDate\n}\n\nfragment ProjectDateChanged on ProjectUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  uuid\n  watching\n  capabilities {\n    canWatchProject\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectMissedUpdateLabel on ProjectUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  project {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectResultRow_data on Project {\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  ...ProjectName_data\n  dueDate {\n    ...TargetDate\n  }\n  state {\n    ...ProjectState\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStatusChanged on ProjectUpdate {\n  newProjectState: newState {\n    ...ProjectState\n  }\n  oldProjectState: oldState {\n    ...ProjectState\n  }\n}\n\nfragment ProjectStatusSummary_data_2v8OKf on Query {\n  projectStatusSummaryForTag(tagUuid: $tagUuid) {\n    atRisk\n    onTrack\n    offTrack\n    paused\n    pending\n    done\n    cancelled\n  }\n}\n\nfragment ProjectTimeline_3zMVyW on Query {\n  projectTimeline: projectTql(first: $pageSize, workspaceUuid: $workspaceUuid, q: $projectTimelineQuery, sort: [STATUS_ASC, TARGET_DATE_ASC, ID_ASC]) {\n    count\n    edges {\n      node {\n        uuid\n        startDate\n        creationDate\n        ...ProjectBar\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ProjectUpdateCard on ProjectUpdate {\n  id\n  uuid\n  missedUpdate\n  updateType\n  creator {\n    aaid\n    id\n  }\n  ...MissedProjectUpdateCard\n  ...ProjectUpdateCardInternal\n  project {\n    uuid\n    id\n  }\n  milestones {\n    count\n  }\n  learnings {\n    count\n  }\n  notes {\n    __typename\n    id\n  }\n}\n\nfragment ProjectUpdateCardContentExtras on ProjectUpdate {\n  ...ProjectUpdateNotes\n  ...ProjectUpdateDiff\n  ...LearningsSummary_data\n  ...MilestonesSummary_data\n  ...ProjectUpdateTargetDateAutoUpdated\n}\n\nfragment ProjectUpdateCardFooter on ProjectUpdate {\n  ari\n  updateType\n  missedUpdate\n  project {\n    ari\n    ...ProjectFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment ProjectUpdateCardHeader on ProjectUpdate {\n  project {\n    ...ProjectFollowButton\n    ...ProjectIcon\n    id\n    key\n    name\n  }\n}\n\nfragment ProjectUpdateCardInternal on ProjectUpdate {\n  id\n  ari\n  project {\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop\n  ...ProjectUpdateSummary\n  ...ProjectUpdateCardContentExtras\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment ProjectUpdateCardTop on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectUpdateCreationDate\n  ...ProjectUpdateStatus\n  ...ProjectMissedUpdateLabel\n}\n\nfragment ProjectUpdateCardTop_PTxnb on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectMissedUpdateLabel\n  missedUpdate\n}\n\nfragment ProjectUpdateCreationDate on ProjectUpdate {\n  id\n  project {\n    key\n    id\n  }\n  creationDate\n  editDate\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n}\n\nfragment ProjectUpdateDiff on ProjectUpdate {\n  ...ProjectDateChanged\n  ...ProjectStatusChanged\n}\n\nfragment ProjectUpdateNotes on ProjectUpdate {\n  notes {\n    uuid\n    ...UpdateNote\n    id\n  }\n}\n\nfragment ProjectUpdateStatus on ProjectUpdate {\n  newDueDate {\n    ...TargetDate\n  }\n  newProjectState: newState {\n    value\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateSummary on ProjectUpdate {\n  summary\n}\n\nfragment ProjectUpdateTargetDateAutoUpdated on ProjectUpdate {\n  project {\n    key\n    id\n  }\n  newTargetDate\n  changelog {\n    newValue\n    oldValue\n    id\n  }\n}\n\nfragment ProjectsAndGoalsTab_data_39RrHn on Query {\n  ...ProjectsSection_data_2D6uC4\n  ...GoalsSection_data_4vWrFT\n  tagByUuid(uuid: $tagUuid) {\n    ...TopicDescription_data\n    id\n  }\n}\n\nfragment ProjectsList_data_3zRwRl on Query {\n  projectTql(first: $pageSize, workspaceUuid: $workspaceUuid, q: $projectFilter, sort: [STATUS_ASC, TARGET_DATE_ASC, ID_ASC], shouldRefetch: true) {\n    count\n    edges {\n      node {\n        id\n        ...ProjectResultRow_data\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ProjectsSection_data_2D6uC4 on Query {\n  tagByUuid(uuid: $tagUuid) {\n    projectUsageCount\n    id\n  }\n  ...ProjectStatusSummary_data_2v8OKf\n  ...ProjectsList_data_3zRwRl @skip(if: $isTimelineView)\n  ...Timeline_data_SdVq0 @include(if: $isTimelineView)\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment TagFollowButton on Tag {\n  id\n  uuid\n  name\n  watching\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment Timeline_data_SdVq0 on Query {\n  projectStatusSummaryForTag(tagUuid: $tagUuid) {\n    atRisk\n    onTrack\n    offTrack\n    paused\n    pending\n    done\n  }\n  ...ProjectTimeline_3zMVyW\n}\n\nfragment TopicContentRefreshed_data_2K8Y9H on Query {\n  tagByUuid(uuid: $tagUuid) {\n    name\n    id\n  }\n  ...HelpAndKnowledgeTab_data_3wgndL @include(if: $shouldFetchKnowledgeTabData)\n  ...UpdatesTab_data_2x0FjB\n  ...ProjectsAndGoalsTab_data_39RrHn @include(if: $shouldFetchProjectAndGoalsTabData)\n}\n\nfragment TopicDescription_data on Tag {\n  uuid\n  description\n}\n\nfragment TopicHeader_data on Tag {\n  name\n  ...TopicName_data\n  ...TopicDescription_data\n  ...TagFollowButton\n}\n\nfragment TopicLearning_data on Learning {\n  ...Learning_data\n  project {\n    watcherCount\n    tags {\n      ...LearningTags_data\n    }\n    id\n  }\n}\n\nfragment TopicName_data on Tag {\n  uuid\n  name\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UpdatesTab_data_2x0FjB on Query {\n  updatesWithTag(tagUuid: $tagUuid, first: 25) @include(if: $shouldFetchUpdatesTabData) {\n    edges {\n      node {\n        __typename\n        ...ProjectUpdateCard\n        ...GoalUpdateCard\n        ... on GoalUpdate {\n          id\n          goal {\n            capabilities {\n              canCommentOnUpdates\n            }\n            id\n          }\n        }\n        ... on ProjectUpdate {\n          id\n          project {\n            capabilities {\n              canCommentOnUpdates\n            }\n            id\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n\nfragment utilsGetProjectTargetEndDate on Project {\n  newPhase {\n    name\n  }\n  startDate\n  creationDate\n  targetDate\n  targetDateConfidence\n  targetDateSet\n}\n"
  }
};
})();

(node as any).hash = "18bcec8976bb5416939c7ecdafe7a022";

export default node;
